<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Marketing from "@/components/crm/marketing.vue";

/**
 * Starter component
 */
export default {
    page: {
        title: "Marketing",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: { Layout, PageHeader, Marketing },
    data() {
        return {
            title: "Marketing",
            items: [
                {
                    text: "Utility",
                    active: true,
                },
            ],
        };
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <Marketing />
    </Layout>
</template>
